module.exports = __webpack_public_path__ + "static/img/icon_logo.59aa236.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_logo.png
// module id = YS2w
// module chunks = 1